import { useUserStore } from "~/store/auth";

export default defineNuxtRouteMiddleware( async (to, from) => {
    const userStore = useUserStore();

    if (!!userStore.user){
        return await navigateTo("/dashboard", { replace: true });
    }
});
